module.exports = __webpack_public_path__ + "tests.html";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./test/tests.html?
// module id = 82
// module chunks = 1 3